// A watcher for the Order Now button, and nothing else.
//
// Three attempts at this bug were made from reasoning alone and all three were
// wrong, so this exists to replace reasoning with a record. It is deliberately
// separate from bliss-bkash-button.js: it can therefore report whether that
// file loaded at all, which is the one thing a failure inside it could never
// tell us.
//
// Switched on by visiting any page with ?blissdebug=1 and remembered for the
// rest of the browsing session, because the interesting moment - a drawer
// opening on a product page - happens a navigation or two after the query
// string is gone. Nothing is shown, stored or sent without that switch, so a
// customer never sees it.

(function () {
  var KEY = 'blissdebug';
  var on = false;
  try {
    if ((location.search || '').indexOf('blissdebug=1') !== -1) sessionStorage.setItem(KEY, '1');
    on = sessionStorage.getItem(KEY) === '1';
  } catch (e) {
    on = (location.search || '').indexOf('blissdebug=1') !== -1;
  }
  if (!on) return;

  var panel;
  var lines = 0;

  // Two rules learned the hard way, both from the same mistake: the first
  // version of this panel sat along the bottom of the screen, which is exactly
  // where the cart drawer pins its Order Now button. It covered the one control
  // it existed to watch, and the button could not be pressed at all.
  //
  // So: it lives at the top, and it does not take pointer events - a press
  // travels straight through it to whatever is underneath. It can obscure
  // something, but it can never block it.
  var MAX_ROWS = 18;

  function say(msg) {
    if (!panel) {
      panel = document.createElement('div');
      panel.style.cssText = 'position:fixed;left:6px;right:6px;top:6px;z-index:2147483647;'
        + 'max-height:40vh;overflow:hidden;background:rgba(16,16,24,.92);color:#9CF29C;'
        + 'font:11px/1.4 ui-monospace,monospace;padding:7px 9px;border-radius:8px;'
        + 'white-space:pre-wrap;word-break:break-word;box-shadow:0 2px 18px rgba(0,0,0,.5);'
        + 'pointer-events:none';
      (document.body || document.documentElement).appendChild(panel);
    }
    var row = document.createElement('div');
    row.textContent = (++lines) + '. ' + msg;
    panel.appendChild(row);
    // Nothing scrolls a panel that ignores the finger, so the oldest lines are
    // dropped instead. The last few are the ones that matter - the press.
    while (panel.childNodes.length > MAX_ROWS) panel.removeChild(panel.firstChild);
  }

  function describe(el) {
    if (!el || !el.tagName) return String(el);
    var cls = '';
    if (el.className && typeof el.className === 'string' && el.className.trim()) {
      cls = '.' + el.className.trim().split(/\s+/).slice(0, 4).join('.');
    }
    return el.tagName.toLowerCase() + (el.id ? '#' + el.id : '') + cls;
  }

  function ours() { return document.querySelectorAll('.bliss-bkash-checkout-btn'); }

  function state(when) {
    say(when
      + ' | url=' + location.pathname
      + ' | button-script-loaded=' + (window.__blissBkashDocWired ? 'YES' : 'NO')
      + ' | our-buttons=' + ours().length);
  }

  // Every click on the page, whatever it lands on. If the press is not even
  // reaching a button of ours, that is the answer and no amount of looking
  // inside the button's own code would ever have found it.
  document.addEventListener('click', function (e) {
    var t = e.target;
    var mine = t && t.closest ? t.closest('.bliss-bkash-checkout-btn') : null;
    say('CLICK ' + describe(t) + (mine ? '  -> IS our button' : '  -> not our button'));
    if (mine) {
      say('   disabled=' + mine.disabled
        + ' working=' + (mine.getAttribute('data-bliss-working') || '-')
        + ' script=' + (window.__blissBkashDocWired ? 'loaded' : 'MISSING'));
    }
  }, true);

  // The button usually arrives long after the page does, carried in with the
  // cart drawer's HTML. Saying so pins down whether it ever turns up.
  var seen = -1;
  function watch() {
    var n = ours().length;
    if (n !== seen) { seen = n; say('our buttons on page: ' + n); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { state('loaded'); watch(); });
  } else {
    state('loaded'); watch();
  }

  if (window.MutationObserver) {
    new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });
  }

  say('watcher on. add a product, open the drawer, press Order Now once.');
})();
